import { motion } from 'framer-motion';

const TermsOfService = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-dark-bg py-12 px-4"
    >
      <div className="container max-w-4xl mx-auto">
        <div className="card p-8">
          <h1 className="section-title mb-8">Terms of Service</h1>
          
          <div className="space-y-6 text-text-secondary">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
              <p>By accessing or using ExamGuard's services, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our services.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. Description of Services</h2>
              <p>ExamGuard provides exam proctoring and technical support services for various online examination platforms. Our services include:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Technical setup and configuration assistance</li>
                <li>Real-time exam monitoring and support</li>
                <li>Troubleshooting for exam platform issues</li>
                <li>Security and integrity assurance</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. User Accounts</h2>
              <p>You must provide accurate and complete information when creating an account. You are responsible for:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized access</li>
                <li>Ensuring you meet eligibility requirements for your specific exams</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Acceptable Use</h2>
              <p>You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Use our services for any illegal purpose</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with other users' exams or accounts</li>
                <li>Share your account credentials with third parties</li>
                <li>Use our services to cheat or violate academic integrity policies</li>
                <li>Upload malicious software or content</li>
                <li>Harass, abuse, or harm other users or our staff</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Payments and Refunds</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>All prices are listed in USD unless otherwise specified</li>
                <li>Payment is required before services are rendered</li>
                <li>Refunds may be granted on a case-by-case basis for services not yet provided</li>
                <li>No refunds for completed services or no-shows</li>
                <li>We reserve the right to modify pricing with notice</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Service Availability</h2>
              <p>We strive to maintain 99% uptime but do not guarantee uninterrupted service. We are not liable for:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Technical issues beyond our control</li>
                <li>Exam platform outages or failures</li>
                <li>Internet connectivity issues on your end</li>
                <li>Force majeure events</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Intellectual Property</h2>
              <p>All content, trademarks, and intellectual property on ExamGuard are owned by us or our licensors. You may not reproduce, distribute, or create derivative works without our express permission.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, ExamGuard shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services. Our total liability shall not exceed the amount you paid for the specific service in question.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">9. Academic Integrity</h2>
              <p>Our services are designed to assist with technical aspects of online proctoring. You remain responsible for:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Understanding and following your institution's academic integrity policies</li>
                <li>Ensuring you are authorized to use external proctoring assistance</li>
                <li>Any violations of exam rules or academic dishonesty</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">10. Termination</h2>
              <p>We may terminate or suspend your account immediately for:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Violation of these Terms</li>
                <li>Fraudulent activity</li>
                <li>Non-payment of fees</li>
                <li>Behavior that harms our platform or other users</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">11. Governing Law</h2>
              <p>These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">12. Changes to Terms</h2>
              <p>We reserve the right to modify these Terms at any time. Continued use of our services after changes constitutes acceptance of the new Terms.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">13. Contact Information</h2>
              <p>For questions about these Terms, contact us at:</p>
              <p className="mt-2 text-primary">legal@examguard.com</p>
            </section>

            <p className="text-sm text-text-gray pt-6 border-t border-border-color">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TermsOfService;